export default "__VITE_ASSET__CRco9hpC__"